import { Play, ArrowRight, Sparkles } from 'lucide-react';

export default function Hero() {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToApplicationPage = () => {
    if (typeof window === 'undefined') return;
    window.location.href = '/basvuru';
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background-dark/60 via-background-dark/40 to-background-light dark:to-background-dark z-10" />
        <img
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80"
          alt="Earth from space"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>

      {/* Animated particles/grid effect */}
      <div className="absolute inset-0 z-0 opacity-20">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjB2NjBIMHoiLz48cGF0aCBkPSJNMCAzMGgzMG0zMC0zMGgzME0wIDYwaDMwbTMwLTMwaDMwIiBzdHJva2U9IiM0MjcyZmYiIHN0cm9rZS1vcGFjaXR5PSIuMiIvPjwvZz48L3N2Zz4=')] bg-repeat" />
      </div>

      <div className="relative z-10 container-custom text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 
                        border border-primary/20 text-primary text-sm font-semibold mb-8 
                        animate-fade-in">
          <Sparkles className="w-4 h-4" />
          Yapay Zeka Destekli Gayrimenkul Tanıtımı
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white 
                       leading-tight mb-6 max-w-5xl mx-auto animate-slide-up">
          Gayrimenkulünüzü{' '}
          <span className="text-primary">Gökyüzünden</span>
          <br className="hidden sm:block" /> Sergileyin
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-slate-200 mb-10 max-w-2xl mx-auto leading-relaxed 
                      animate-slide-up animation-delay-100">
          Uydu görüntüleri ve yapay zeka ile saniyeler içinde büyüleyici emlak 
          videoları oluşturun. Portföyünüzü rakiplerinizden farklılaştırın.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 
                        animate-slide-up animation-delay-200">
          <button
            onClick={goToApplicationPage}
            className="w-full sm:w-auto px-8 py-4 bg-primary text-white font-bold text-lg 
                       rounded-xl hover:scale-105 transition-transform shadow-xl 
                       shadow-primary/30 flex items-center justify-center gap-2"
          >
            Hemen Ucretsiz Basla
            <ArrowRight className="w-5 h-5" />
          </button>
          <button
            onClick={() => scrollToSection('#demo-video')}
            className="w-full sm:w-auto px-8 py-4 bg-white/10 text-white font-bold text-lg 
                       rounded-xl border border-white/20 hover:bg-white/20 transition-colors 
                       flex items-center justify-center gap-2 backdrop-blur-sm"
          >
            <Play className="w-5 h-5" />
            Örnek Videolar
          </button>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl mx-auto 
                        animate-slide-up animation-delay-300">
          {[
            { value: '10K+', label: 'Üretilen Video' },
            { value: '500+', label: 'Mutlu Müşteri' },
            { value: '4K', label: 'Video Kalitesi' },
            { value: '3dk', label: 'Ortalama Süre' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-black text-white">{stat.value}</div>
              <div className="text-sm text-slate-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
}
